<template>
  <div id="ourServices">
    <div class="more-serve">
      <span @click="jump">{{ this.$t("lang.Home.more") }}</span
      ><span class="iconfont">&#xe641;</span>
    </div>
    <ul class="img-list">
      <el-row :gutter="15">
        <el-col :span="6" v-for="item of imageList" :key="item.id">
          <li
            class="list-item"
            @mouseenter="handleMouseEnter(item.id)"
            @mouseleave="handleMouseLeave(item.id)"
          >
            <div class="item-img">
              <transition name="el-fade-in-linear">
                <img v-show="item.flag" :src="item.src" alt="" />
              </transition>
              <transition name="el-fade-in-linear">
                <div v-show="!item.flag" :class="language">
                  {{ item.content }}
                </div>
              </transition>
              <p class="iconfont triangle">&#xe63f;</p>
            </div>
            <p class="item-content">{{ item.title }}</p>
          </li>
        </el-col>
      </el-row>
    </ul>
  </div>
</template>

<script>
export default {
  name: "OurServices",
  data() {
    return {
      imageList: [
        {
          flag: true,
          id: 1,
          src: require("../../assets/images/ourserve/zhuanjiamenzhen.png"),
          title: this.$t("lang.Home.ourServices.expertsOutpatient"),
          content: this.$t("lang.Home.ourServices.expertsOutpatientDetail")
        },
        {
          flag: true,
          id: 2,
          src: require("../../assets/images/ourserve/zhuanjiashoushu.png"),
          title: this.$t("lang.Home.ourServices.expertsOperation"),
          content: this.$t("lang.Home.ourServices.expertsOperationDetail")
        },
        {
          flag: true,
          id: 3,
          src: require("../../assets/images/ourserve/zhuanjiabingfang.png"),
          title: this.$t("lang.Home.ourServices.expertWard"),
          content: this.$t("lang.Home.ourServices.expertWardDetail")
        },
        {
          flag: true,
          id: 4,
          src: require("../../assets/images/ourserve/yuanchenghuizhen.png"),
          title: this.$t("lang.Home.ourServices.longDistance"),
          content: this.$t("lang.Home.ourServices.longDistanceDetail")
        },
        {
          flag: true,
          id: 5,
          src: require("../../assets/images/ourserve/guojizhuanzhen.png"),
          title: this.$t("lang.Home.ourServices.internationalMedical"),
          content: this.$t("lang.Home.ourServices.internationalMedicalDetail")
        },
        {
          flag: true,
          id: 6,
          src: require("../../assets/images/ourserve/jiangkangbaoxian.png"),
          title: this.$t("lang.Home.ourServices.HealthInsurance"),
          content: this.$t("lang.Home.ourServices.HealthInsuranceDetail")
        },
        {
          flag: true,
          id: 7,
          src: require("../../assets/images/ourserve/aizhengshaicha.png"),
          title: this.$t("lang.Home.ourServices.cancerScreening"),
          content: this.$t("lang.Home.ourServices.cancerScreeningDetail")
        },
        {
          flag: true,
          id: 8,
          src: require("../../assets/images/ourserve/jiyinjiance.png"),
          title: this.$t("lang.Home.ourServices.geneTesting"),
          content: this.$t("lang.Home.ourServices.geneTestingDetail")
        }
      ],
      language: ""
    };
  },
  mounted() {
    this.setStyle();
    console.log(this.$i18n.locale)
  },
  beforeUpdate() {
    this.setStyle();
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleMouseEnter(id) {
      for (let i = 0; i < this.imageList.length; i++) {
        if (id === this.imageList[i].id) {
          this.imageList[i].flag = !this.imageList[i].flag;
        }
      }
    },
    handleMouseLeave(id) {
      for (let i = 0; i < this.imageList.length; i++) {
        if (id === this.imageList[i].id) {
          this.imageList[i].flag = !this.imageList[i].flag;
        }
      }
    },
    jump() {
      this.$router.push({
        path: "./BestMedicalCare",
        query: {
          id: "our-serve"
        }
      });
    },
    setStyle() {
      if (this.$i18n.locale === "en-US") {
        this.language = "item-detail-us";
      } else if (this.$i18n.locale === "zh-CN") {
        this.language = "item-detail";
      }
    }
  },
  computed: {
    imageLists() {
      return [
        {
          flag: true,
          id: 1,
          src: require("../../assets/images/ourserve/zhuanjiamenzhen.png"),
          title: this.$t("lang.Home.ourServices.expertsOutpatient"),
          content: this.$t("lang.Home.ourServices.expertsOutpatientDetail")
        },
        {
          flag: true,
          id: 2,
          src: require("../../assets/images/ourserve/zhuanjiashoushu.png"),
          title: this.$t("lang.Home.ourServices.expertsOperation"),
          content: this.$t("lang.Home.ourServices.expertsOperationDetail")
        },
        {
          flag: true,
          id: 3,
          src: require("../../assets/images/ourserve/zhuanjiabingfang.png"),
          title: this.$t("lang.Home.ourServices.expertWard"),
          content: this.$t("lang.Home.ourServices.expertWardDetail")
        },
        {
          flag: true,
          id: 4,
          src: require("../../assets/images/ourserve/yuanchenghuizhen.png"),
          title: this.$t("lang.Home.ourServices.longDistance"),
          content: this.$t("lang.Home.ourServices.longDistanceDetail")
        },
        {
          flag: true,
          id: 5,
          src: require("../../assets/images/ourserve/guojizhuanzhen.png"),
          title: this.$t("lang.Home.ourServices.internationalMedical"),
          content: this.$t("lang.Home.ourServices.internationalMedicalDetail")
        },
        {
          flag: true,
          id: 6,
          src: require("../../assets/images/ourserve/jiangkangbaoxian.png"),
          title: this.$t("lang.Home.ourServices.HealthInsurance"),
          content: this.$t("lang.Home.ourServices.HealthInsuranceDetail")
        },
        {
          flag: true,
          id: 7,
          src: require("../../assets/images/ourserve/aizhengshaicha.png"),
          title: this.$t("lang.Home.ourServices.cancerScreening"),
          content: this.$t("lang.Home.ourServices.cancerScreeningDetail")
        },
        {
          flag: true,
          id: 8,
          src: require("../../assets/images/ourserve/jiyinjiance.png"),
          title: this.$t("lang.Home.ourServices.geneTesting"),
          content: this.$t("lang.Home.ourServices.geneTestingDetail")
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#ourServices {
  width: 75%;
  min-width: 960px;
  margin: 0 auto;
  overflow: hidden;

  .more-serve {
    color: #aaaaaa;
    text-align: right;
    /*margin-right: 20px;*/
    margin-bottom: 30px;
    span {
      cursor: pointer;
      color: $publicBlue;
    }
  }
  .img-list {
    .list-item:hover {
      cursor: pointer;
      .item-img {
        border: 1px solid #2789ea;
        .triangle {
          color: #2789ea;
        }
      }
      .item-content {
        color: #2789ea;
      }
    }
    .list-item {
      /*height: 240px;*/
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .item-img {
        border: 1px solid #dddddd;
        width: 99%;
        height: 190px;
        box-shadow: 0 0 1px #e6e6e6 inset;
        /*border-bottom: 1px solid #000;*/
        position: relative;
        img {
          width: 100%;
          height: 100%;
          box-shadow: 0 0 1px #e6e6e6 inset;
          position: absolute;
        }
        .item-detail {
          margin: 10px 15px;
          color: #aaaaaa;
          font-size: 14px;
          text-indent: 2em;
          text-align: left;
          position: absolute;
          line-height: 22px;
        }
        .item-detail-us {
          word-break: break-all;
          margin: 10px 15px;
          color: #aaaaaa;
          font-size: 12px;
          text-indent: 2em;
          text-align: left;
          position: absolute;
          line-height: 16px;
        }
      }
      .triangle {
        font-size: 10px;
        transform: rotate(180deg);
        position: absolute;
        bottom: -3px;
        left: 47%;
        color: #e6e6e6;
      }
      .item-content {
        margin-top: 30px;
        text-align: center;
        height: 30px;
        color: #aaaaaa;
      }
    }
  }
}
</style>
